export const BuildInfo = {timestamp:1778780698000}
